import React, { useEffect, useState, lazy, Suspense } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import styles from './ClinicPatientPlanoAlimentar.module.scss';
import { Row, Col } from 'react-bootstrap';
import Loader from '../components/Loader';
import PatientHeader from '../components/PatientHeader';
import { PlanoAlimentarProvider } from '../contexts/PlanoAlimentarContext';
import { alertModal } from '../utils/modalController';
import { fetchAuth } from '../utils/fetchAuth';

const PlanoAlimentarEdit = lazy(() => import('../components/PlanoAlimentarEdit'));
const apiUrl = process.env.REACT_APP_API_URL || '';

const ClinicPatientPlanoAlimentar: React.FC = () => {

    const [user, setUser] = useState<User | null>(null);
    const [age, setAge] = useState<number | null>(null);
    const [planoAlimentarName, setPlanoAlimentarName] = useState<string>('Plano Alimentar');
    const [loading, setLoading] = useState(true);

    const { id } = useParams<{ id: string }>();
    const { planoAlimentarId } = useParams<{ planoAlimentarId: string }>();
    const [searchParams] = useSearchParams();
    const consultaId = searchParams.get('consulta');

    useEffect(() => {
        Promise.all([
            fetchAuth(`${apiUrl}/consultorio/patients/${id}`),
        ])
            .then(async ([patientRes]) => {
                if (!patientRes.ok) {
                    const error_json = await patientRes.json();
                    throw new Error(error_json.message || "Erro desconhecido");
                }

                const patientJson = await patientRes.json();

                if(!patientJson.user){
                    throw new Error("Usuário não encontrado");
                }

                const userRes = await fetchAuth(`${apiUrl}/consultorio/users/${patientJson.user.id}`);
                if (!userRes.ok) {
                    const error_json = await userRes.json();
                    throw new Error(error_json.message || "Erro desconhecido");
                }

                const userJson = await userRes.json();

                setUser(userJson);
                setAge(userJson?.birthday ? Math.floor((new Date().getTime() - new Date(userJson.birthday).getTime()) / (1000 * 60 * 60 * 24 * 365)) : null);
            })
            .catch((err) => {
                console.error('Erro ao buscar dados:', err);
                alertModal('Erro ao buscar dados: ' + err);
                setUser(null);
                setAge(null);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [id]);

    if (loading) return <Loader />;

    return (
        <PlanoAlimentarProvider>
            <Container className={styles.container}>
                <h2 className={styles.title}>Consultório</h2>
                {loading ? (
                    <Loader />
                ) : (
                    <>
                        <Row className={styles["row-card"]}>
                            <Col>
                                <PatientHeader
                                    user={user!}
                                    age={age}
                                    breadcrumbItems={[
                                        { label: "Consultório", href: "/consultorio" },
                                        { label: "Pacientes", href: "/consultorio/pacientes" },
                                        { label: user?.name || "Paciente", href: `/consultorio/pacientes/${id}` },
                                        ...(!consultaId
                                            ? [
                                                { label: "Planos Alimentares", href: `/consultorio/pacientes/${id}/planos-alimentares` }
                                            ]
                                            : [
                                                { label: "Consultas", href: `/consultorio/pacientes/${id}/consultas` },
                                                { label: "Consulta", href: `/consultorio/pacientes/${id}/consultas/${consultaId}` },
                                            ]),
                                        { label: planoAlimentarName || "Plano Alimentar" },
                                    ]}

                                />
                            </Col>
                        </Row>
                        <Suspense fallback={<Loader />}>
                            <PlanoAlimentarEdit
                                planoAlimentarId={planoAlimentarId ?? '0'}
                                patientId={id ?? '0'}
                                consultaId={consultaId ?? undefined}
                                onChange={(planoAlimentar: PlanoAlimentar) => {
                                    setPlanoAlimentarName(planoAlimentar.nome);
                                }}
                            />
                        </Suspense>
                    </>
                )}
            </Container>
        </PlanoAlimentarProvider>
    );
};

export default ClinicPatientPlanoAlimentar;
